import DigitalDiceWrapper from './DigitalDiceWrapper';

export default DigitalDiceWrapper;
